import { render, staticRenderFns } from "./ModalChangeOrdersApprove.vue?vue&type=template&id=6a5e6a4d&lang=pug&"
import script from "./ModalChangeOrdersApprove.vue?vue&type=script&lang=js&"
export * from "./ModalChangeOrdersApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports